<template>
	<div v-if="cro_params">
		<van-sticky>
			<div class="rcst_sc">
				<div @click="backPrev()" class="rcst_sc_drop">
					<div class="rcst_sc_drop_left">
						<img src="../demo1/source/back.png" alt="" />
					</div>
				</div>
				<div class="rcst_sc_drop_center">创建订单</div>
			</div>
		</van-sticky>
		
		<div class="scpz_head ">
			<div class="scpz_head_title">{{cro_params.venue_name}}</div>
			<div class="scpz_head_tag">{{cro_params.course_name}}</div>
		</div>
		<div class="scoi_out">
			<div class="scoi">
				<div class="scoi_title">预约信息</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约日期</div>
					<div class="scoi_item_right scoi_item_right_orange" style="background-image: none;">
						{{cro_params.date}}
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约时间</div>
					<div class="scoi_item_right scoi_item_right_orange" style="background-image: none;">
						{{cro_params.time}}
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">预约人</div>
					<div class="scoi_item_right" style="background-image: none;">
						<input type="text" placeholder="请输入姓名" maxlength="20" style="text-align: right;" />
					</div>
				</div>
				<div class="scoi_item">
					<div class="scoi_item_left">手机号</div>
					<div class="scoi_item_right" style="background-image: none;">
						<input v-model="book_phone" type="number" placeholder="请输入手机号" maxlength="11" style="text-align: right;" />
					</div>
				</div>
			</div>
		</div>

		<div class="scop_out">

			<div class="scop">
				<div class="scop_block">
					<div class="scop_block_title">价格明细</div>
					<div class="scop_block_item">
						<div class="scop_block_item_left">单价</div>
						<div class="scop_block_item_right">
							¥0
						</div>
					</div>
					<div class="scop_block_item">
						<div class="scop_block_item_left">数量</div>
						<div class="scop_block_item_right">1</div>
					</div>
					<div class="scop_block_item">
						<div class="scop_block_item_left">权益券码</div>
						<div class="scop_block_item_right">
							<input v-model="discount_code" type="number" placeholder="请输入权益券码" maxlength="99" style="text-align: right;border: none;outline: none;" />
						</div>
					</div>
					<!-- <div class="scop_block_item">
						<div class="scop_block_item_left"></div>
						<div class="scop_block_item_right">
							合计：<div class="scop_block_item_right_orange" style="color: #F77F28;">¥{{discount_code.length>0?'0':good_detail.price}}</div>
						</div>
					</div> -->
				</div>
			</div>
			<div class="scop_protol">如需退订,请提前24小时申请</div>
		</div>
		<div class="scoi_bot">
			<div @click="submitOrder()">提交订单</div>
		</div>
	</div>
</template>

<script>
	import {
		futureTimesGroup,
	} from "../../lib/utils.js"
	export default {
		data() {
			return {
				book_date: '',
				book_time:'',
				goodsId: '',
				good_detail:null,
				discount_code:'',
				cro_params:null,
				book_phone:''
			}
		},
		mounted() {
			var $this=this
			console.log(this.$route.params);
			this.cro_params=this.$route.params
			this.book_date = this.$route.params.date
			this.book_time=this.$route.params.time
			this.course_timetable_id = this.$route.params.course_timetable_id
			// :course_timetable_id/:date/:time',
			// this.getDetail()
			setTimeout(()=>{
				$this.getUserInfo()
			},50)
		},
		methods: {
			getUserInfo(){
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.demo1_user_info
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						if(res.data && res.data.userMobile){
							$this.book_phone=res.data.userMobile
						}else{
							$this.book_phone=localStorage.getItem('phone')
							// $this.$router.go(0)
						}
					}).catch((error) => {
						console.warn(error)
						$this.$toast('网络异常');
					})
			},
			backPrev(){
				this.$router.go(-1)
			},
			getDetail() {
				var $this = this
				var param = {
					goods_id: this.goodsId
				}
				var qs = require('qs');
				let url = this.api.userApi.demo1_getVenueGoodsInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						$this.good_detail = res.data
					}).catch((error) => {
						console.warn(error)
						$this.$toast('网络异常');
					})
			},
			selectSportTypeDate(e) {
				this.date_index = e
			},
			switchRuleType(e) {
				this.rule_type = e
			},
			toSplCreateOrder() {

			},
			submitOrder(){
				this.$toast('订单提交成功');
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	
	.rcst_sc {
		width: 100%;
		/* padding: 0 30*@vm_base; */
		padding: 0 30*@vm_base;
		// padding: 0 0 20*@vm_base 0;
		background-color: #fff;
		
		display: flex;
		justify-content: space-between;
		align-items: center;
	
		.rcst_sc_drop {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			width: fit-content;
			
			.rcst_sc_drop_left{
				width: 80*@vm_base;
				height: 80*@vm_base;
				// border: 1*@vm_base solid red;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				img{
					width: 36*@vm_base;
				}
			}
		}
		.rcst_sc_drop_center{
			width: calc(100% - 80*@vm_base);
			height: 80*@vm_base;
			padding-right: 80*@vm_base;
			font-size: 28*@vm_base;
			color: #666666;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.scpz_head {
		width: 100%;
		background-color: #ffffff;
		padding: 40*@vm_base;

		.scpz_head_title {
			width: 100%;
			font-weight: 600;
			font-size: 36*@vm_base;
			color: #333333;
		}

		.scpz_head_tag {
			width: fit-content;
			font-size: 30*@vm_base;
			height: 50*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #F77F28;
			-webkit-text-stroke: 0px #F77F28;
			border-radius: 8*@vm_base;
			border: 1*@vm_base solid #F77F28;
			padding: 0 20*@vm_base;
			margin-top: 30*@vm_base;
		}
	}

	.scoi_out {
		width: 100%;
		padding: 0 20*@vm_base;

		.scoi {
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base;
			margin-top: 20*@vm_base;


			.scoi_title {
				font-weight: 600;
				font-size: 30*@vm_base;
				color: #333333;
				line-height: 1.36;
			}

			.scoi_item {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-top: 30*@vm_base;
				font-size: 28*@vm_base;
			}

			.scoi_item_left {
				color: #666666;
				white-space: nowrap;
			}

			.scoi_item_right {
				color: #333333;
				// padding: 0 30*@vm_base;
				background-image: url(https://526ocvgabaebpth66ic1-1315430534.cos.ap-shanghai.myqcloud.com/healthy_image/20240725_by1a5xaY5hc36DJ.png);
				background-size: 28*@vm_base;
				background-repeat: no-repeat;
				background-position: right center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				input{
					border: none;
					outline: none;
				}
			}

			.scoi_item_right_orange {
				color: #F77F28;
			}
		}

	}


	.scop_out {
		width: 100%;
		padding: 0 20*@vm_base;
		margin-top: 20*@vm_base;



		.scop {
			width: 100%;
			padding: 30*@vm_base 0;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
		}

		.scop_block {
			padding: 0 20*@vm_base;
		}

		.scop_block_title {
			font-weight: 600;
			font-size: 30*@vm_base;
			color: #333333;
			line-height: 1.36;
		}

		.scop_block_item {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 28*@vm_base;
			margin-top: 30*@vm_base;
		}

		.scop_block_item_left {
			color: #666666;
			line-height: 1.36;
		}

		.scop_block_item_right {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #333333;
			line-height: 1.36;
			// padding-right: 30*@vm_base;
			background-size: 30*@vm_base;
			background-repeat: no-repeat;
			background-position: right center;
			// color: #F77F28;
		}

		.scop_block_item_right_tag {
			min-width: 130*@vm_base;
			width: fit-content;
			white-space: nowrap;
			background: linear-gradient(90deg, #262322 0%, #4A4442 100%);
			border-radius: 8*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 6*@vm_base 14*@vm_base;
			font-size: 22*@vm_base;
			color: #FFDDB0;
			margin-right: 10*@vm_base;
		}

		.scop_block_item_right_retail {
			font-size: 24*@vm_base;
			color: #999999;
			text-decoration: line-through;
			padding-right: 50*@vm_base;
		}
		.scop_protol{
			color: #F77F28;
			padding: 30*@vm_base 0;
		}
	}

	.scoi_bot{
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 40*@vm_base;
		background-color: #F6F7F9;
		div{
			width: 100%;
			height: 80*@vm_base;
			border-radius: 16*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 28*@vm_base;
			color: #ffffff;
			background-color: #F77F28;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/demo1/createorder2.vue